export class Configuration {
  // ini untuk dev
  // public static get BASE_URL(): string { return "http://dev.nostratech.com:20024/api/"; };
  //ini untuk sit
  // public static get BASE_URL(): string { return "http://dev.nostratech.com:20025/api/"; };
  //ini untuk prod
  public static get BASE_URL(): string { return "https://api.mufit.id/api/"; };
  public static get SENDEMAIL(): string { return "client-registration/send-email"; };
  public static get ACTIVATECLIENT(): string { return "client-registration/activate-client"; };
  public static get REGISTRATION_CONFIRMATION(): string { return "registration/confirmation"; };
  public static get SENDEMAILFORGOT(): string { return "forgot-password/send-email"; };
  public static get CHANGEFORGOTPASSWORD(): string { return "forgot-password/"; };  
  public static get CHANGE_PASS(): string { return "forgot-password/change-password"}; 
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/services/base-services/configuration.ts